// extracted by mini-css-extract-plugin
module.exports = {"vfContainer":"e_Mq","followed":"e_Nq","followedIcon":"e_Oq","follow":"e_Pq","followIcon":"e_Qq"};